import PropConfigList from "../component/PropConfigList";
import React from "react";

const PropConfigListContainer = ({ pageId }) => (<PropConfigList pageId={pageId} />)

export default PropConfigListContainer;